<!--
 * @Author: your name
 * @Date: 2022-01-11 18:03:20
 * @LastEditTime: 2022-03-14 20:26:43
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/changma202201/components/video.vue
-->
<!--
    视频模块
-->
<template>
    <div id="video">
        <video ref="video" data-v-3b1260f5="" id="vido_one"
        controls="controls" preload="auto"
        webkit-playsinline="" :poster="poster" muted="muted" autoplay="autoplay"
        playsinline="" x5-video-player-type="h5" class="video__player poster">
            <source :src="src" type="video/mp4">
        </video>
        <div class="guide" v-show="!playing"></div>
    </div>
</template>
<script>
import maidian from '@/utils/maidian';
export default {
    props:['src','poster'],
    data() {
        return {
            playing: false
        }
    },
    mounted() {
        document.addEventListener('touchstart', () => {
            this.playing = true;
            document.getElementById('vido_one').play();
        });
        setTimeout(() => {
            document.getElementById('vido_one').play();
        }, 300);
        document.getElementById('vido_one').addEventListener('playing',  ()=> {
            maidian.eventBind('videoOnePlay');
            this.playing = true;
        });
    },
    methods:{
        pause(){
            // document.getElementById("myaudio").pause();
            this.$refs.video.pause();
        }
    }
}
</script>
<style lang="less" scoped>
    #video{
        height: 211px;
        overflow-y: hidden;
        position:relative;
    }
    .guide{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: url(https://campaigns-static.volvocars.com.cn/image/images/xc60_xw3_v01_play.jpg) no-repeat center/100%;
    }
    video{
        width:100%;
        height:211px;
        margin-left:auto;
        margin-right:auto;
    }
</style>
